import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function StickyNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About the Home',
    href: '#about'
  }, {
    name: 'Why North Scottsdale',
    href: '#why-carefree'
  }, {
    name: 'Schedule a Tour',
    href: '#schedule'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/90 backdrop-blur-md border-b border-sand/30 py-4' : 'bg-cream py-6'}`} data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-114">
        {/* Logo */}
        <a href="#" className="flex flex-col leading-tight" data-id="element-115">
          <span className="font-serif text-2xl md:text-3xl font-semibold tracking-wide text-stone-deep" data-id="element-116">
            Labenske + Patton
          </span>
          <span className="font-sans text-[10px] md:text-xs uppercase tracking-[0.25em] text-sand mt-0.5" data-id="element-117">
            HomeSmart NEXT
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-118">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm uppercase tracking-widest text-stone-deep/80 hover:text-brown transition-colors duration-200" data-id="element-119">
              {link.name}
            </a>)}
        </nav>

        {/* CTA */}
        <div className="hidden md:block" data-id="element-120">
          <a href="#schedule" className="bg-stone-deep text-cream px-6 py-3 rounded-full text-sm uppercase tracking-widest hover:bg-brown transition-colors duration-300" data-id="element-121">
            Request Info
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-stone-deep" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-122">
          {mobileMenuOpen ? <X size={28} data-id="element-123" /> : <Menu size={28} data-id="element-124" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-cream border-b border-sand/30 shadow-lg py-6 px-6 flex flex-col space-y-6" data-id="element-125">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-base uppercase tracking-widest text-stone-deep hover:text-brown transition-colors duration-200" data-id="element-126">
              {link.name}
            </a>)}
          <a href="#schedule" onClick={() => setMobileMenuOpen(false)} className="bg-stone-deep text-cream text-center px-6 py-4 rounded-full text-sm uppercase tracking-widest hover:bg-brown transition-colors duration-300" data-id="element-127">
            Request Info
          </a>
        </div>}
    </header>;
}